import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const clinics = [
    {
      name: 'Electronic City Clinic',
      phones: ['+91 91084 24084', '+91 96320 74737']
    },
    {
      name: 'Koramangala Clinic',
      phones: ['+91 91085 76094', '+91 91089 86094']
    },
    {
      name: 'Marathahalli Clinic',
      phones: ['+91 91087 36094', '+91 99801 04737']
    }
  ];

  return (
    <footer className="bg-dark-text text-cream">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
            <img 
              src="/images/logo.png" 
              alt="Amrita Sparsha" 
              className="h-16 mb-4"
            />
            <p className="text-sm leading-relaxed mb-4">
              Amrita Sparsha is a wellness extension of Amrita Homeopathy, offering doctor-guided care and carefully formulated wellness products.
            </p>
            <Link 
              to="/disclaimer" 
              className="text-golden hover:text-light-gold transition-colors text-sm"
              data-testid="footer-disclaimer-link"
            >
              Medical Disclaimer →
            </Link>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-golden font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-golden transition-colors" data-testid="footer-home-link">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-golden transition-colors" data-testid="footer-about-link">
                  About Doctor
                </Link>
              </li>
              <li>
                <Link to="/products" className="hover:text-golden transition-colors" data-testid="footer-products-link">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-golden transition-colors" data-testid="footer-contact-link">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-golden font-semibold mb-4">Our Clinics</h3>
            <div className="space-y-4 text-sm">
              {clinics.map((clinic, index) => (
                <div key={index} data-testid={`footer-clinic-${index}`}>
                  <p className="font-medium text-light-gold mb-1">{clinic.name}</p>
                  {clinic.phones.map((phone, phoneIndex) => (
                    <a 
                      key={phoneIndex}
                      href={`tel:${phone.replace(/\s/g, '')}`} 
                      className="flex items-center hover:text-golden transition-colors mb-1"
                      data-testid={`footer-phone-${index}-${phoneIndex}`}
                    >
                      <Phone size={14} className="mr-2" />
                      {phone}
                    </a>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Amrita Sparsha. All rights reserved.</p>
          <p className="mt-2 text-xs text-gray-400">
            This website is for informational purposes only and does not constitute medical advice.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;